import React, {useState} from "react";
import { auth, provider } from "../config/FirebaseConfig";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, updateProfile, fetchSignInMethodsForEmail} from "firebase/auth";
import { collection, addDoc, setDoc, doc} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import styles from './Login.module.css';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { db } from "../config/FirebaseConfig";
import { Typography } from "@mui/material";


function Login({ setIsAuth }) {
  let navigate = useNavigate();

  const [userName, setUserName] = useState()
  const [password, setPassword] = useState()
  const [isSignInPage, setIsSignInPage] = useState(true)
  const [isLoading, setIsLoading] = useState(false)

  //validation stuff
  const [isUserNameEmpty, setIsUserNameEmpty] = useState(false)
  const [shortLongUserName, setShortLongUserName] = useState(false)
  const [invalidUserNameFormat, setInvalidUserNameFormat] = useState(false)
  const [isPwdEmpty, setIsPwdEmpty] = useState(false)
  const [shortLongPwd, setShortLongPwd] = useState(false)
  const [invalidPwdFormat, setInvalidPwdFormat] = useState(false)

  const [isUserNameTaken, setIsUserNameTaken] = useState(false)
  const [wrongNamePwd, setWrongNamePwd] = useState(false)
  
  const usersCollectionRef = collection(db, "users");
  

  const signInWithUserName = () => {

    //reset the correct states for after a first faild try 
    if(userName.length) setIsUserNameEmpty(false)
    if(userName.length >= 5) setShortLongUserName(false)
    if(password.length) setIsPwdEmpty(false)
    if(password.length >= 6) setShortLongPwd(false)

    if(!userName.length){
      setIsUserNameEmpty(true)
      return
    }
    if(userName.length < 5){
      setShortLongUserName(true)
      return
    }
    if(!password.length){
      setIsPwdEmpty(true)
      return
    }
    if(password.length < 6){
      setShortLongPwd(true)
      return
    }
    
    setIsLoading(true)

    let convertUserNameToEmail = userName + '@uniConfess.sa'

    signInWithEmailAndPassword(auth, convertUserNameToEmail, password)
    .then(async (userCredential) => {
      // Signed in
      const user = userCredential.user;
      let userData = user
      userData.displayName = userName
      localStorage.setItem("isAuth", true);
      console.log("popo?: ", user)
      localStorage.setItem("userData", JSON.stringify(userData));

      setIsAuth(true)
      navigate("/sfu")
      setIsLoading(false)
    
    }).catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      if(errorCode === 'auth/wrong-password' || errorCode === 'auth/user-not-found'){
          setWrongNamePwd(true)
      }
      if(errorCode === 'auth/invalid-email'){
        setInvalidUserNameFormat(true)
      }

      console.log("Error with Sign In user. Code: ", errorCode, "errorMessage: ", errorMessage)
      setIsLoading(false)
    });

  }

  const isEmailTaken = async () => {

    if(!userName){
      setIsUserNameTaken(false)
      return
    }

    let convertUserNameToEmail = userName + '@uniConfess.sa'

    await fetchSignInMethodsForEmail(auth, convertUserNameToEmail).then((result) => {
      if(result.length){
        setIsUserNameTaken(true)
      }else{ 
        setIsUserNameTaken(false)
      }
    }).catch((error) => {
      console.log("fetchSignInMethodsForEmail error:", error)
    });

  }

  const signUpWithUserName = () => {

    setWrongNamePwd(false)

    if(userName.length) setIsUserNameEmpty(false)
    if(userName.length >= 5) setShortLongUserName(false)
    if(password.length) setIsPwdEmpty(false)
    if(password.length >= 6) setShortLongPwd(false)

    if(!userName.length){
      setIsUserNameEmpty(true)
      return
    }
    if(userName.length < 5){
      setShortLongUserName(true)
      return
    }
    if(!password.length){
      setIsPwdEmpty(true)
      return
    }
    if(password.length < 6){
      setShortLongPwd(true)
      return
    }

    setIsLoading(true)
    
    let convertUserNameToEmail = userName + '@uniConfess.sa'

    createUserWithEmailAndPassword(auth, convertUserNameToEmail, password)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      let userData = user
      userData.displayName = userName
      localStorage.setItem("isAuth", true);
      localStorage.setItem("userData", JSON.stringify(userData));

      updateProfile(auth.currentUser, {
        displayName: userName
      }).then(async () => {
        console.log("updateProfile success")

        await addDoc(usersCollectionRef, {

          })
          await setDoc(doc(db, "users", userData.uid), {
            name: userName,
            id: userData.uid,
            reloadUserInfo: userData.reloadUserInfo,
            university: {
              short: 'sfu',
              long: 'simon fraser university (sfu)'
            },
            lastTimeAddedPost: null
          }, { merge: true }).then(() => {
            setIsAuth(true)
            navigate("/sfu")
            setIsLoading(false)
          }).catch((error) => {
            console.log("create user error: ", error)
          })
      
      }).catch((error) => {
        console.log("updateProfile error", error)
      });
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      if(errorCode === 'auth/invalid-email'){
        setInvalidUserNameFormat(true)
      }
      console.log("Error with create user. Code: ", errorCode, "errorMessage: ", errorMessage)
      setIsLoading(false)
    });
  }



  return (
    <Grid
    container
    spacing={0}
    //direction="column"
    alignItems="center"
    justifyContent="center">
      <Grid item xs={3}>
        <Stack spacing={3} sx={{mb:12}}>
          <Typography variant="h4" sx={{mb:2}}>{isSignInPage ? 'Sign In' : 'Sign Up'}</Typography>
          <TextField
            className={styles.TextField}
            margin='normal'
            required
            id="outlined-basic"
            label="Display name"
            variant="outlined"
            size="small"
            onBlur={() => !isSignInPage && isEmailTaken()}
            inputProps={{ maxLength: 20 }}
            onChange={(userName)=> setUserName(userName.target.value)}
            error={isUserNameEmpty || shortLongUserName || invalidUserNameFormat || isUserNameTaken || invalidUserNameFormat}
            helperText={
              <div >
                {isUserNameEmpty && [`The display name should not be empty.`, <br/>]}
                {shortLongUserName && [`The display name has to be at least 5 characters and at most 20.`, <br/>]}
                {isUserNameTaken && [`This name is already taken!`, <br/>]}
                {wrongNamePwd && [`We did not find any account associated with the name and password provided.`, <br/>]}
                {invalidUserNameFormat && 'The format of the display name is invalid'}
              </div>
            }
          />
          <TextField 
            required
            id="outlined-basic"
            margin='normal'
            label="Password"
            variant="outlined"
            type="password"
            inputProps={{ maxLength: 20 }}
            onChange={(password)=> setPassword(password.target.value)}
            error={isPwdEmpty || shortLongPwd || invalidPwdFormat}
            helperText={
              <div>
                {isPwdEmpty && [`The password should not be empty.`, <br/>]}
                {shortLongPwd && `The password has to be at least 6 characters and at most 20.`}
              </div>
            }
            //autoComplete="current-password"
            size="small"
          />
          {isSignInPage?  
            <LoadingButton 
            loading={isLoading}
            onClick={() => signInWithUserName()}
            variant="contained"
            color="error"
            margin='normal'
            sx={{mt: 2}}
          >
            LogIn
          </LoadingButton> :
          <LoadingButton 
            loading={isLoading}
            onClick={() => signUpWithUserName()}
            variant="contained"
            color="error"
            margin='normal'
            sx={{mt: 2}}
          >
            Sign Up
          </LoadingButton>
          }
          {!isSignInPage ?
            <Button onClick={() => {setIsSignInPage(true); setIsUserNameTaken(false)}} variant="text">Sign In</Button> :
            <Button onClick={() => setIsSignInPage(false)} variant="text">Sign Up</Button>
          }
        </Stack>
      </Grid>
    </Grid>
  );
}

export default Login;
